export class ApiListResponse<T> {
  count: number;
  next: number;
  previous: number;
  results: Array<T>;
}
